"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chainPropTypes;

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/~/@material-ui/utils/chainPropTypes.js
// module id = 228
// module chunks = 0